export function validateIconType(icon, expectedType) {
    if (icon.type !== expectedType) {
        throw `${icon.name}: Icon type "${icon.type}" does not match expected type "${expectedType}"`;
    }
}
